const AlertBlock = ({ block }) => {
  const content = block.content;
  const type = content.type || "info";
  
  return (
    <div className={`alert-block ${type}`}>
      {content.title && <div className="alert-block-title">{content.title}</div>}
      <div className="alert-block-message">{content.message}</div>
    </div>
  );
};

export default AlertBlock;